



















import { Component, Vue, Watch } from 'vue-property-decorator'
import { uiStore } from '@/store'

@Component
export default class App extends Vue {
  get uiStore() {
    return uiStore
  }
  private get notification() {
    return this.uiStore.notification.status
  }

  /** Indica el tema visual a utilizar (light o dark) */
  private get theme() {
    return this.uiStore.theme
  }

  /** Cierra la notificacion actual */
  private closeNotificacion() {
    this.uiStore.notification.hide()
  }

  @Watch('$route')
  updatePageName() {
    document.title = this.$route.name || 'Sistema de Denuncias'
  }
}
